import React, { useState } from 'react'
//import { Link } from 'react-router-dom'
//import { BiLeftArrow } from 'react-icons/bi'

const UserPanelNavbar = ({setScreen}) => {

    const [activeButton, setActiveButton] = useState("PerfilUser");

    const handleButtonPress = (screen) => {
        setScreen(screen);
        setActiveButton(screen);
      }

  return (
    <div className='w-full h-20 bg-background_home flex flex-row items-center top-0 sticky'>
         {/* <Link to='/adminpanel' className='hover:bg-green-800 h-full'>
           <div className='flex flex-row gap-2 h-full text-white w-24 p-2 items-center justify-center hover:text-slate-300'>
              <BiLeftArrow />
              <p>VOLVER</p>
           </div>
        </Link>  */}

        <div className='w-full h-full flex flex-row items-center'>
            <div className={`h-full w-1/3 flex items-center justify-center text-white ${activeButton === "PerfilUser" ? "bg-green-800" : ""}`}>
              <button onClick={()=>handleButtonPress('PerfilUser')}>PERFIL</button>
            </div>
            <div className={`h-full w-1/3 flex items-center justify-center text-white ${activeButton === "FormulariosAdmin" ? "bg-green-800" : ""}`}>
              <button onClick={()=>handleButtonPress('FormulariosAdmin')}>FORMULARIOS</button>
            </div>
            <div className={`h-full w-1/3 flex items-center justify-center text-white ${activeButton === "Renovaciones" ? "bg-green-800" : ""}`}>
              <button onClick={()=>handleButtonPress('Renovaciones')}>RENOVACIONES</button>
            </div>

        </div>
    </div>
  )
}

export default UserPanelNavbar